<template>
    <div>
        <limitless-page-header
            :loading="!initialized && busy_loading"
            :sub-title="(id > 0 && card_serie ? card_serie.SeriesName : (not_found ? '???' : 'Ny kortserie'))"
            :title-id="(card_serie && card_serie.CardSeriesID > 0 ? card_serie.CardSeriesID : '')"
        >
            <template #header-elements>
                <limitless-page-header-button url="/cardseries" icon="icon-list-unordered">Lista</limitless-page-header-button>
            </template>
        </limitless-page-header>
        <div class="content" v-if="!initialized && busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="!not_found && card_serie">
            <div class="alert alert-danger" v-if="valid_range === false">
                Utbudet innehåller produkter med fel momssats!!
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-header bg-light">
                            <h6 class="card-title"><i class="icon-pencil position-left"></i> <span class="text-semibold">Redigera kortserie</span></h6>
                        </div>
                        <div class="card-table">
                            <form @submit.prevent="saveCardSerie">
                                <ValidationObserver ref="serieform">
                                    <table class="table">
                                        <tbody>
                                        <tr>
                                            <td class="font-weight-semibold">
                                                Serie: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="CardSeriesID" name="Serie" rules="required" v-slot="{ errors }">
                                                    <div>
                                                        <input type="text" class="form-control d-inline-block" v-model="card_serie.CardSeriesID" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}" :disabled="id>0">
                                                        1-29: 100 000 kort, 300-999: 10 000 kort
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Korttyp: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="CardTypeID" name="Korttyp" rules="required" v-slot="{ errors }">
                                                    <v-select
                                                        v-model="card_serie.CardTypeID"
                                                        :options="card_serie_types"
                                                        :reduce="item => item.id"
                                                        :class="{'has-validation-error':(!!errors[0])}"
                                                        placeholder="Välj..."
                                                    />
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Benämning: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="SeriesName" name="Benämning" rules="required" v-slot="{ errors }">
                                                    <input type="text" class="form-control d-inline-block" v-model="card_serie.SeriesName" v-bind:class="{'border-danger':errors[0]}">
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Benämning Kort: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="SeriesNameShort" name="Benämning Kort" rules="required" v-slot="{ errors }">
                                                    <input type="text" class="form-control d-inline-block" v-model="card_serie.SeriesNameShort" v-bind:class="{'border-danger':errors[0]}">
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Antal val: <span v-if="!card_serie.IsPoints" class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="NoOfChoices" name="Antal val" :rules="{numeric: true, required:!card_serie.IsPoints, min_value: (!card_serie.IsPoints ? 1 : '') }" v-slot="{ errors }">
                                                    <div><input type="number" min="0" step="1" class="form-control d-inline-block" v-bind:class="{'border-danger':errors[0]}"
                                                                v-model="card_serie.NoOfChoices" style="width: 100px;" :disabled="card_serie.IsPoints==1"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Poängkort:
                                            </td>
                                            <td>
                                                <div class="form-check form-check-inline">
                                                    <label class="form-check-label">
                                                        <input type="checkbox" class="form-check-input" v-model="card_serie.IsPoints" :true-value="1" :false-value="0">
                                                        Poängkort
                                                    </label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Moms %: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="VAT" name="Moms %" rules="required|numeric" v-slot="{ errors }">
                                                    <div><input type="text" class="form-control d-inline-block" v-model="card_serie.VAT" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Konto: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="Account" name="Konto" rules="required|numeric" v-slot="{ errors }">
                                                    <div><input type="text" class="form-control d-inline-block" v-model="card_serie.Account" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Leveransgrupp: <span class="text-danger">*</span>
                                            </td>
                                            <td>
                                                <select-with-validation
                                                    component="delivery-group-filter"
                                                    vid="DeliveryGroup"
                                                    label="Leveransgrupp"
                                                    rules="required"
                                                    placeholder="Välj..."
                                                    v-model="card_serie.DeliveryGroup"
                                                    :reduce="item => item.id"
                                                    hide-label
                                                    class="mb-0"
                                                ></select-with-validation>
                                            </td>
                                        </tr>

<!--                                        <tr>-->
<!--                                            <td class="font-weight-semibold">-->
<!--                                                Standardflaggor:-->
<!--                                            </td>-->
<!--                                            <td>-->
<!--                                                <div class="form-check form-check-inline">-->
<!--                                                    <label class="form-check-label">-->
<!--                                                        <input type="checkbox" class="form-check-input" v-model="standard_flags" value="1">-->
<!--                                                        Std.-->
<!--                                                    </label>-->
<!--                                                </div>-->
<!--                                                <div class="form-check form-check-inline">-->
<!--                                                    <label class="form-check-label">-->
<!--                                                        <input type="checkbox" class="form-check-input" v-model="standard_flags" value="2">-->
<!--                                                        Xtra Webb.-->
<!--                                                    </label>-->
<!--                                                </div>-->
<!--                                                <div class="form-check form-check-inline">-->
<!--                                                    <label class="form-check-label">-->
<!--                                                        <input type="checkbox" class="form-check-input" v-model="standard_flags" value="4">-->
<!--                                                        Ö-skott Webb.-->
<!--                                                    </label>-->
<!--                                                </div>-->
<!--                                            </td>-->
<!--                                        </tr>-->

<!--                                        <tr>-->
<!--                                            <td class="font-weight-semibold">-->
<!--                                                Priskategori:-->
<!--                                            </td>-->
<!--                                            <td>-->
<!--                                                <ValidationProvider vid="CardPriceCat" name="Priskategori" rules="" v-slot="{ errors }">-->
<!--                                                    <v-select-->
<!--                                                        v-model="card_serie.CardPriceCat"-->
<!--                                                        :options="price_categories"-->
<!--                                                        label="text"-->
<!--                                                        :reduce="item => item.id"-->
<!--                                                        :class="{'has-validation-error':(!!errors[0])}"-->
<!--                                                        placeholder="Välj..."-->
<!--                                                    />-->
<!--                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>-->
<!--                                                </ValidationProvider>-->
<!--                                            </td>-->
<!--                                        </tr>-->

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Voucher typ:
                                                <i class="icon-question3 ml-2" id="pop-voucher"></i>
                                                <b-popover key="pop-voucher" target="pop-voucher" triggers="hover focus">
                                                    <div class="mb-2">Enfunktionsvouchers kräver att kortets produktsortiment endast innehåller produkter med en och samma momsstats. Korten faktureras med moms specificerat på fakturan.</div>
                                                    <div>Flerfunktionsvouchers får innehålla ett produktsortiment där produkterna har olika momsstatser. Korten faktureras UTAN moms.</div>
                                                </b-popover>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="voucher_type" name="Voucher typ" rules="" v-slot="{ errors }">
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input id="chk-item-voucher-0" type="radio" class="custom-control-input" v-model="card_serie.voucher_type" :value="0">
                                                        <label for="chk-item-voucher-0" class="custom-control-label">Ej voucher</label>
                                                    </div>
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input id="chk-item-voucher-1" type="radio" class="custom-control-input" v-model="card_serie.voucher_type" :value="1">
                                                        <label for="chk-item-voucher-1" class="custom-control-label">Enfunktionsvoucher</label>
                                                    </div>
                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input id="chk-item-voucher-2" type="radio" class="custom-control-input" v-model="card_serie.voucher_type" :value="2">
                                                        <label for="chk-item-voucher-2" class="custom-control-label">Flerfunktionsvoucher</label>
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Produktutbud från kortserie:
                                            </td>
                                            <td>
                                                <ValidationProvider vid="ProductRangeCardSeriesID" name="Produktutbud från kortserie" rules="" v-slot="{ errors }">
                                                    <v-select
                                                        v-model="card_serie.ProductRangeCardSeriesID"
                                                        :options="productRangeCardSeriesOptions"
                                                        :get-option-label="(s) => s.CardSeriesID + ': ' + s.SeriesName"
                                                        :reduce="item => item.CardSeriesID"
                                                        :class="{'has-validation-error':(!!errors[0])}"
                                                        placeholder="Eget produktutbud"
                                                    />
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Pris (kr):
                                            </td>
                                            <td>
                                                <ValidationProvider vid="CardPrice" name="CardPrice" rules="" v-slot="{ errors }">
                                                    <div><input type="number" min="0" step="0.01" class="form-control d-inline-block" v-model="card_serie.CardPrice" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Gåvofrakt (kr):
                                            </td>
                                            <td>
                                                <ValidationProvider vid="GiftFreightPrice" name="GiftFreightPrice" rules="" v-slot="{ errors }">
                                                    <div><input type="number" min="0" step="0.01" class="form-control d-inline-block" v-model="card_serie.GiftFreightPrice" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">Bild:</td>
                                            <td>
                                                <ValidationProvider vid="ImageID" name="Bild" v-slot="{ errors }">
                                                    <div style="max-width: 300px;">
                                                        <mediabank-selector
                                                            v-model="card_serie.ImageID"
                                                            btn-text="Välj bild"
                                                            btn-icon="icon-image2"
                                                            thumbnail
                                                        />
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">Tryckformat:</td>
                                            <td>
                                                <ValidationProvider vid="PrintFormat" name="Tryckformat" v-slot="{ errors }">
                                                    <card-serie-print-format v-model="card_serie.PrintFormat" :presets="print_formats" :disabled="busy_saving" />
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Standard Produkturval:
                                                <i class="icon-question3 ml-2" id="pop-cardflags"></i>
                                                <b-popover key="pop-cardflags" target="pop-cardflags" triggers="hover focus">
                                                    <div>Detta styr vad som blir automatiskt ikryssat när denna kortserie läggs in på en order.</div>
                                                </b-popover>
                                            </td>
                                            <td>
                                                <ValidationProvider vid="default_card_flags_array" name="Standard Produkturval" rules="" v-slot="{ errors }">
                                                    <div>
                                                        <div class="custom-control custom-checkbox custom-control-inline">
                                                            <input id="chk-item-flag-1" type="checkbox" class="custom-control-input" v-model="card_serie.default_card_flags_array" :value="1">
                                                            <label for="chk-item-flag-1" class="custom-control-label">Standardsortiment</label>
                                                        </div>
    <!--                                                        <div class="custom-control custom-checkbox custom-control-inline mt-2">-->
    <!--                                                            <input id="chk-item-flag-2" type="checkbox" class="custom-control-input" v-model="card_serie.default_card_flags_array" :value="2">-->
    <!--                                                            <label for="chk-item-flag-2" class="custom-control-label">Xtra Webb.</label>-->
    <!--                                                        </div>-->
                                                        <div class="custom-control custom-checkbox custom-control-inline">
                                                            <input id="chk-item-flag-4" type="checkbox" class="custom-control-input" v-model="card_serie.default_card_flags_array" :value="4">
                                                            <label for="chk-item-flag-4" class="custom-control-label">Överskottsprodukter</label>
                                                        </div>
                                                    </div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Aktiv för försäljning:
                                            </td>
                                            <td>
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input id="chk-isforsale" type="checkbox" class="custom-control-input" v-model="card_serie.isForSale"  :true-value="1" :false-value="0">
                                                    <label for="chk-isforsale" class="custom-control-label">Aktiv</label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Sortering:
                                            </td>
                                            <td>
                                                <ValidationProvider vid="SortNo" name="Sortering" rules="numeric" v-slot="{ errors }">
                                                    <div><input type="text" class="form-control d-inline-block" v-model="card_serie.SortNo" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-semibold">
                                                Beställningspunkt:
                                            </td>
                                            <td>
                                                <ValidationProvider vid="OrderPoint" name="Beställningspunkt" rules="numeric" v-slot="{ errors }">
                                                    <div><input type="text" class="form-control d-inline-block" v-model="card_serie.OrderPoint" style="width: 100px;" v-bind:class="{'border-danger':errors[0]}"></div>
                                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </td>
                                        </tr>
                                        <tr><td colspan="2" class="p-0"></td></tr>
                                        </tbody>
                                    </table>
                                </ValidationObserver>
                            </form>
                        </div>
                        <div class="card-body row">
                            <div class="col-12 text-right">
                                <limitless-button ref="btnsaveserie" type="button" @click="saveCardSerie" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4" v-if="id>0">
                    <div class="card">
                        <div class="card-header bg-light">
                            <h6 class="card-title"><i class="icon-stack-picture position-left"></i> <span class="text-semibold">Kort</span></h6>
                        </div>
                        <div class="card-body">
                            <table class="table table-xs table-striped">
                                <tbody>
                                    <tr>
                                        <th>Antal genererade</th>
                                        <td>{{ (stats.card_total_amount ? stats.card_total_amount : 0) }}</td>
                                    </tr>
                                    <tr>
                                        <th>Antal aktiverade</th>
                                        <td>{{ (stats.card_activated_amount ? stats.card_activated_amount : 0) }}</td>
                                    </tr>
                                    <tr>
                                        <th>Kvar att aktivera</th>
                                        <td>{{ ((stats.card_total_amount ? stats.card_total_amount : 0) - (stats.card_activated_amount ? stats.card_activated_amount : 0)) }}</td>
                                    </tr>
                                    <tr>
                                        <th>Kvar att generera</th>
                                        <td>
                                            <span v-if="card_serie.CardSeriesID<1000">
                                                {{ (99999 - (parseInt(card_serie.NextSerial, 10) - 1) ) }}
                                            </span>
                                            <span v-else-if="card_serie.CardSeriesID>=1000 && card_serie.CardSeriesID<=4929">
                                                {{ (99999 - (parseInt(card_serie.NextSerial, 10) - 1) ) }}
                                            </span>
                                            <span v-else>
                                                {{ (9999 - (parseInt(card_serie.NextSerial, 10) - 1) ) }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="card_serie.cards_generated.length>0">
                                <table class="table table-striped table-xs mt-3">
                                    <thead>
                                        <tr>
                                            <th>Antal kort</th>
                                            <th>Genereringsdatum</th>
                                            <th>Genererad av</th>
                                            <th> </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(gen, g_idx) in card_serie.cards_generated" :key="'gen-' + g_idx">
                                            <td>{{ (parseInt(gen.LastCard)-parseInt(gen.FirstCard)+1) }}</td>
                                            <td>{{ gen.GeneratedTS }}</td>
                                            <td>{{ gen.user.FullName }}</td>
                                            <td><a :href="'/cardseries/' + card_serie.CardSeriesID + '/export_card_numbers?start_no=' + gen.FirstCard + '&end_no=' + gen.LastCard">Hämta utskriftsfil</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="text-right mt-2">
                                    <a :href="'/cardseries/' + card_serie.CardSeriesID + '/export_card_numbers?start_no=1&end_no=99999'" class="btn btn-light"><span class="icon-download4 mr-2"></span>Hämta utskriftsfil med alla kort</a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-form-label col-md-4">
                                    Generera kort
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="Antal kort" v-model="num_cards_to_generate">
                                        <span class="input-group-append">
                                            <limitless-button ref="btngenerate" type="button" @click="generateCards" saved-text="KLAR!" :busy="busy_generating">Generera</limitless-button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header bg-light">
                            <h6 class="card-title"><i class="icon-cube3 position-left"></i> <span class="text-semibold">Lagersaldo</span></h6>
                        </div>
                        <div class="card-body">
                            <form class="form-horizontal">
                                <input type="hidden" name="func" value="updatestock">
                                <input type="hidden" name="old_stock" value="">
                                <div class="row form-group mb-2">
                                    <div class="col-md-4 col-form-label">Saldo</div>
                                    <div class="col-md-8"><input type="text" class="form-control" :value="stats.card_total_stock-stats.card_total_delivered" readonly></div>
                                </div>

                                <div class="row form-group mb-2">
                                    <div class="col-md-4 col-form-label">Reserverat</div>
                                    <div class="col-md-8"><input type="text" class="form-control" :value="stats.card_total_booked" readonly></div>
                                </div>

                                <div class="row form-group mb-2">
                                    <div class="col-md-4 col-form-label">Disponibelt</div>
                                    <div class="col-md-8"><input type="text" class="form-control" :value="stats.card_total_stock-stats.card_total_delivered-stats.card_total_booked" readonly></div>
                                </div>

                                <div class="row form-group mb-0">
                                    <div class="col-md-4 col-form-label">Justera saldo</div>
                                    <div class="col-md-8">
                                        <div class="input-group">
                                            <input type="text" class="form-control" v-model="new_card_stock">
                                            <span class="input-group-append">
                                                <limitless-button ref="btnstock" class="btn btn-primary" type="button" @click="updateCardStock" saved-text="KLAR!" :busy="busy_stock">Justera</limitless-button>
                                            </span>
                                        </div>
                                        <span class="text-muted">För att ange nytt saldo (inventering), skriv t.ex. "=100".</span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header bg-light">
                            <h6 class="card-title"><i class="icon-database-diff position-left"></i><span class="text-semibold">Manuella saldoändringar</span></h6>
                        </div>
                        <div v-if="stock_changes.length>0" class="card-body">
                            <table class="table table-striped table-xs mt-20">
                                <thead>
                                <tr>
                                    <th>Datum</th>
                                    <th>Ändring</th>
                                    <th>Kommentar</th>
                                    <th>Ändrat av</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(sal, s_idx) in stock_changes" :key="'sal-' + s_idx">
                                    <td>{{ sal.CreatedTS }} {{ sal.week }}</td>
                                    <td><span v-if="sal.Quantity>0">+</span>{{ sal.Quantity }}</td>
                                    <td>{{ sal.Comment }}</td>
                                    <td>{{ sal.FullName }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="card-body">
                            <i>Inga manuella saldoändringar gjorda</i>
                        </div>
                    </div>
                </div>
            </div>

            <product-range-selection
                v-if="card_serie.voucher_type > 0"
                ref="prodrange"
                :card-serie-id="this.id"
                :show="show_product_range"
                :autoload="false"
                :show-as-page="false"
                :read-only="parseInt(card_serie.ProductRangeCardSeriesID, 10) > 0"
                :product-range-card-series-id="card_serie.ProductRangeCardSeriesID"
            >
                <template v-slot:header>
                    <h6 class="card-title">
                        <i class="icon-cube3 mr-2"></i>Produktutbud
                    </h6>
                    <div class="header-elements">
                        <limitless-button v-if="!show_product_range" @click="showProductRange" btn-class="btn-light">Visa</limitless-button>
                    </div>
                </template>
            </product-range-selection>

            <order-list v-if="show_orders" :card-series-id="id"></order-list>
            <div v-else class="card">
                <div class="card-header header-elements-inline bg-white">
                    <h6 class="card-title">
                        <i class="icon-cart5 mr-2"></i>Ordrar
                    </h6>
                    <div class="header-elements">
                        <limitless-button @click="showOrders" btn-class="btn-light">Visa</limitless-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-else-if="not_found">
            <i>Kortserien finns inte</i>
        </div>
        <div class="content" v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import CardSeriePrintFormat from '@components/CardSeriePrintFormat.vue';
import MediabankSelector from '@components/MediabankSelector.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import ProductRangeSelection from '@app/pages/cardseries/ProductRangeSelection';
import vSelect from 'vue-select';
import getError from '@services/ErrorHelper';
import Vue from 'vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import OrderList from '@app/pages/cardorder/partials/OrderList.vue';

export default {
    name: 'CardSerieEdit',
    components: {
        CardSeriePrintFormat,
        MediabankSelector,
        OrderList,
        SelectWithValidation,
        ProductRangeSelection,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        vSelect,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        busy_generating: false,
        busy_stock: false,
        card_serie: null,
        valid_range: true,
        stats: [],
        stock_changes: [],
        standard_flags: [],
        num_cards_to_generate: '',
        new_card_stock: '',
        show_product_range: false,
        show_orders: false,
        price_categories: [],
        print_formats: [],
        card_serie_types: [],
        product_range_cardseries: [],
        saved_product_range_card_series_id: null,
    }),
    mounted() {
        BackendRepository.getCardSeriesTypes().then((res) => {
            this.card_serie_types = res;
        });
        BackendRepository.getCardSeriesPriceCategories().then((res) => {
            this.price_categories = res;
        });
        apiClient.get('/vue/cardseries?show_hidden=1&only_series=1&per_page=10000')
            .then((response) => {
                this.product_range_cardseries = response.data.data;
            });
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
        standard_flags() {
            let defaultCardFlags = 0;
            this.standard_flags.forEach((flag) => {
                defaultCardFlags += parseInt(flag, 10);
            });
            this.card_serie.defaultCardFlags = defaultCardFlags;
        },
        // eslint-disable-next-line func-names
        'card_serie.NoOfChoices': function (val) {
            if (val === '') {
                this.card_serie.NoOfChoices = 0;
            }
        },
        // eslint-disable-next-line func-names
        'card_serie.IsPoints': function (val) {
            if (val) {
                this.card_serie.NoOfChoices = 0;
            }
        },
    },
    computed: {
        productRangeCardSeriesOptions() {
            if (!this.card_serie) {
                return [];
            }

            return this.product_range_cardseries.filter((serie) => (
                parseInt(serie.CardSeriesID, 10) !== parseInt(this.card_serie.CardSeriesID, 10)
                && !parseInt(serie.ProductRangeCardSeriesID, 10)
            ));
        },
    },
    methods: {
        init() {
            this.getCardSerie();
        },
        async getCardSerie() {
            const vm = this;
            this.busy_loading = true;

            await apiClient.get('/vue/cardseries/' + this.id)
                .then((response) => {
                    Vue.set(vm, 'card_serie', response.data.card_serie);
                    vm.print_formats = response.data.print_formats || [];
                    Vue.set(vm, 'stats', response.data.stats);
                    Vue.set(vm, 'stock_changes', response.data.stock_changes);
                    Vue.set(vm, 'valid_range', response.data.valid_range);
                    Vue.set(vm, 'saved_product_range_card_series_id', parseInt(response.data.card_serie.ProductRangeCardSeriesID, 10) || null);
                    vm.calculateFlags();
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        Vue.set(vm, 'not_found', true);
                    }
                })
                .finally(() => {
                    Vue.set(vm, 'busy_loading', false);
                    Vue.set(vm, 'initialized', true);
                });
        },
        async saveCardSerie() {
            const vm = this;
            const isValid = await vm.$refs.serieform.validate();
            if (isValid) {
                const previousProductRangeCardSeriesID = vm.saved_product_range_card_series_id;
                vm.busy_saving = true;
                await apiClient.post('/vue/cardseries/' + vm.id, vm.card_serie)
                    .then((response) => {
                        if (parseInt(vm.id, 10) !== parseInt(response.data.card_serie.CardSeriesID, 10)) {
                            window.location.href = '/cardseries/' + response.data.card_serie.CardSeriesID;
                        }
                        Vue.set(vm, 'card_serie', response.data.card_serie);
                        Vue.set(vm, 'stats', response.data.stats);
                        Vue.set(vm, 'stock_changes', response.data.stock_changes);
                        Vue.set(vm, 'valid_range', response.data.valid_range);
                        vm.calculateFlags();
                        if (
                            vm.show_product_range
                            && (parseInt(response.data.card_serie.ProductRangeCardSeriesID, 10) || null) !== previousProductRangeCardSeriesID
                        ) {
                            vm.$refs.prodrange.load();
                        }
                        Vue.set(vm, 'saved_product_range_card_series_id', parseInt(response.data.card_serie.ProductRangeCardSeriesID, 10) || null);
                        vm.$refs.btnsaveserie.triggerSaved();
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.serieform.setErrors(parsederror);
                        }
                        vm.$refs.btnsaveserie.triggerFailed();
                    }).finally(() => {
                        vm.busy_saving = false;
                    });
            } else {
                vm.$refs.btnsaveserie.triggerFailed();
            }
        },
        async generateCards() {
            const vm = this;
            vm.busy_generating = true;
            await apiClient.post('/vue/cardseries/' + vm.id + '/generate_cards', {
                number_of_cards: vm.num_cards_to_generate,
            }).then(() => {
                vm.getCardSerie();
                vm.$refs.btngenerate.triggerSaved();
            }).catch(() => {
                vm.$refs.btngenerate.triggerFailed();
            }).finally(() => {
                vm.busy_generating = false;
            });
        },
        async updateCardStock() {
            const vm = this;
            vm.busy_stock = true;
            await apiClient.post('/vue/cardseries/' + vm.id + '/update_stock', {
                stock: vm.new_card_stock,
            }).then(() => {
                vm.getCardSerie();
                vm.new_card_stock = '';
                vm.$refs.btnstock.triggerSaved();
            }).catch(() => {
                vm.$refs.btnstock.triggerFailed();
            }).finally(() => {
                vm.busy_stock = false;
            });
        },
        calculateFlags() {
            const arr = [];
            // eslint-disable-next-line no-bitwise
            if (this.card_serie.defaultCardFlags & 1) {
                arr.push('1');
            }
            // eslint-disable-next-line no-bitwise
            if (this.card_serie.defaultCardFlags & 2) {
                arr.push('2');
            }
            // eslint-disable-next-line no-bitwise
            if (this.card_serie.defaultCardFlags & 4) {
                arr.push('4');
            }
            this.standard_flags = arr;
        },
        showProductRange() {
            this.$refs.prodrange.load().then(() => {
                this.show_product_range = true;
            });
        },
        showOrders() {
            this.show_orders = true;
        },
    },
};
</script>
